<template>
  <v-main style="min-height: 70vh">
    <v-container class="responsive-template-content">
      <v-row dense>
        <v-col cols="12">
          <v-col class="col-md-12 col-sm-12 col-xs-12">
            <v-card color="white" dark class="rounded-xl">
              <v-card-title
                class="justify-center text-h5 font-weight-light"
                style="color: #1976d2"
              >
                <v-icon style="padding-right: 0.3em; color: #1976d2"
                  >mdi-book-account-outline</v-icon
                >
                Gérer mes annonces sauvegardées
              </v-card-title>

              <v-card-subtitle>
                <section
                  style="background: rgba(255, 255, 255, 0.9); color: #777171"
                >
                  <v-col>
                    <v-card light>
                      <v-card-title>
                        <v-text-field
                          v-model="search"
                          append-icon="mdi-magnify"
                          label="Rechercher"
                          single-line
                          hide-details
                          light
                        ></v-text-field>
                      </v-card-title>
                      <v-data-table
                        :headers="headers"
                        :items="savedOffersData"
                        class="elevation-1"
                        light
                        :search="search"
                        :footer-props="{
                          'items-per-page-text': 'Alertes par page',
                          'items-per-page-options': [5, 10, 15, 20],
                        }"
                      >
                        <template v-slot:item.actions="{ item }">
                          <v-btn @click="displayItem(item)">
                            <v-icon small title="Consulter cette offre">
                              mdi-eye-settings-outline
                            </v-icon>
                            Consulter
                          </v-btn>
                          <v-btn @click="deleteItem(item)">
                            <v-icon
                              small
                              title="Supprimer cette offre de mes sauvegardes"
                            >
                              mdi-delete
                            </v-icon>
                            Supprimer
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-col>
                </section>
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-col>
        <v-row justify="center">
          <v-dialog v-model="dialog" persistent max-width="400">
            <v-card>
              <v-card-title class="text-h5"> </v-card-title>
              <v-card-text
                >Vous êtes sur le point de supprimer une annonce sauvegardée.
                Cette opération est irréversible. Souhaitez vous
                continuer?</v-card-text
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" @click="deleteItemForReal" text>
                  Oui, supprimer
                </v-btn>
                <v-btn color="red darken-1" text @click="dialog = false">
                  Non
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-snackbar
            v-model="snackbarSuccess"
            elevation="24"
            color="green darken-3"
          >
            <span class="text-subtitle-1">
              L'offre n'est plus associée à vos sauvegardes.
            </span>
            <template v-slot:action="{ attrs }">
              <v-btn
                color="black"
                text
                v-bind="attrs"
                @click="snackbarSuccess = false"
              >
                Fermer
              </v-btn>
            </template>
          </v-snackbar>
          <v-snackbar
            v-model="snackbarFailed"
            rounded="pill"
            elevation="24"
            color="red darken-3"
          >
            <span class="text-subtitle-1">
              Une erreur s'est produite lors de la suppression.
            </span>
            <template v-slot:action="{ attrs }">
              <v-btn
                color="black"
                text
                v-bind="attrs"
                @click="snackbarFailed = false"
              >
                Fermer
              </v-btn>
            </template>
          </v-snackbar>
        </v-row>
      </v-row>
      <v-row>
        <ViewJobOffer
          :display-dialog="displayJobOffer"
          :job-offer="jobOfferToView"
          v-if="renderViewJobModal"
          v-bind:display-save-button-props="false"
          :hideModalComponentCallback="hideModalComponent"
        />
      </v-row>
    </v-container>
  </v-main>
</template>

<script>
import Vue from "vue";
import HttpClient from "@/services/HttpClient/HttpClient";
import ViewJobOffer from "@/components/Candidate/ViewJobOffer";

export default Vue.extend({
  name: "CandidateMySavedOffer",
  components: { ViewJobOffer },
  data: () => ({
    search: "",
    dialog: false,
    snackbarFailed: false,
    snackbarSuccess: false,
    headers: [
      {
        text: "Offre",
        align: "start",
        sortable: true,
        value: "work",
      },
      { text: "Publiée par", value: "company", sortable: true },
      { text: "Date de sauvegarde", value: "savedAt", sortable: true },
      { text: "Actions", value: "actions", sortable: false },
    ],
    savedOffersData: [],
    savedOffers: null,
    currentSavedOfferToDelete: null,
    displayJobOffer: false,
    jobOfferToView: null,
    renderViewJobModal: false,
  }),
  computed: {},

  watch: {},

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      const httpClient = new HttpClient();
      httpClient
        .getCurrentUserSavedJobOffers(localStorage.getItem("jwt-token"))
        .then((res) => {
          this.savedOffers = res.data;
          this.savedOffersData = [];
          res.data.map((elt) => {
            this.savedOffersData.push({
              work: elt.jobOffer.job.name + " - " + elt.jobOffer.type.name,
              company: elt.jobOffer.company.name,
              savedAt: new Date(elt.savedAt).toLocaleString("fr-FR"),
              id: elt.jobOffer.id,
            });
          });
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push("/logout");
          } else {
            alert("Une erreur s'est produite");
          }
        });
    },
    hideModalComponent: function () {
      this.renderViewJobModal = false;
    },
    deleteItem(item) {
      this.dialog = true;
      this.currentSavedOfferToDelete = item;
    },
    deleteItemForReal() {
      this.dialog = false;
      const item = this.currentSavedOfferToDelete;
      this.currentSavedOfferToDelete = null;
      const httpClient = new HttpClient();
      console.log(item);
      httpClient
        .deleteSavedOffer(item.id, localStorage.getItem("jwt-token"))
        .then(() => {
          this.snackbarSuccess = true;
          this.initialize();
          setTimeout(() => {
            this.snackbarSuccess = false;
          }, 3000);
        })
        .catch((error) => {
          if (error.response.status === 401) {
            this.$router.push("/logout");
          } else {
            this.snackbarFailed = true;
            setTimeout(() => {
              this.snackbarFailed = false;
            }, 3000);
          }
        });
    },
    displayItem(item) {
      this.renderViewJobModal = true;
      this.jobOfferToView =
        this.savedOffers[this.savedOffersData.indexOf(item)].jobOffer;
      this.displayJobOffer = true;
    },
  },
});
</script>

<style scoped></style>
